import { Message } from "element-ui";

export { delay, pollUntilCondition, copyToClipboard, completeThisJob, documentApproved, documentRejected, taskCreatedMessage, taskUpdateMessage, taskAssignToMe };

const delay = (interval) => {
  return new Promise((resolve) => setTimeout(resolve, interval));
};

const pollUntilCondition = async (
  pollingFunction,
  conditionFunction,
  interval
) => {
  while (true) {
    console.log("pollUntilCondition");
    const result = await pollingFunction();
    console.log("result", result);
    if (conditionFunction(result)) {
      return result;
    }
    await delay(interval);
  }
};

const copyToClipboard = async (string, type) => {
  try {
    if (type == 'copyText') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Text copied to clipboard',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to copy text',
      type: 'error',
    });
  }
};

const completeThisJob = async (string, type) => {
  try {
    if (type == 'completeJob') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Job Completed',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to complete job',
      type: 'error',
    });
  }
};

const documentApproved = async (string, type) => {
  try {
    if (type == 'documentApproved') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Document Approved',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to complete job',
      type: 'error',
    });
  }
};

const documentRejected = async (string, type) => {
  try {
    if (type == 'documentRejected') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Document Rejected',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to complete job',
      type: 'error',
    });
  }
};

const taskCreatedMessage = async (string, type) => {
  try {
    if (type == 'taskCreated') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Task created successfully',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to complete job',
      type: 'error',
    });
  }
};

const taskUpdateMessage = async (string, type) => {
  try {
    if (type == 'taskUpdated') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Task update successfully',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to complete job',
      type: 'error',
    });
  }
};

const taskAssignToMe = async (string, type) => {
  try {
    if (type == 'taskAssignToMe') {
      await navigator.clipboard.writeText(string);
    } else {
      var type = "text/html";
      var blob = new Blob([string], { type });
      var data = [new ClipboardItem({ [type]: blob })];
      await navigator.clipboard.write(data)
    }


    Message({
      showClose: true,
      message: 'Task assigned successfully',
      type: 'success',
    });

  } catch (error) {
    Message({
      showClose: true,
      message: 'Failed to assigned task',
      type: 'error',
    });
  }
};
